import { call, put, takeLatest } from 'redux-saga/effects';
import { repositories } from 'api';
import * as types from './types';
import { fetchSimpleProduct as actions } from './actions';

export { actions };

const simpleProduct = new repositories.SimpleProduct();

type Action = {
    type: string;
    payload: string;
};

function* fetchSimpleProductInfo(action: Action) {
    try {
        const simpleProductData = yield call<any>([simpleProduct, 'get'], { slug: action.payload });

        yield put(actions.success(simpleProductData.data));
    } catch (error) {
        yield put(actions.failure(error.response.data));
    }
}

function* simpleProductSaga() {
    yield takeLatest<any>(types.FETCH_SIMPLE_PRODUCT_REQUEST, fetchSimpleProductInfo);
}

export default simpleProductSaga;
